
import { Button, Input } from 'components/ui'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { TbSend } from 'react-icons/tb';
import { CompanyContext } from 'contexts/CompanyContext';
import ChatTemplateMessage from './ChatTemplateMessage';
import { socialNetworks } from 'views/calendar/SocialNetworkSidePanel';
import capitalize from 'components/ui/utils/capitalize';
import { useWhitelabel } from 'contexts/WhitelabelThemeContext';

export default function ChatTemplateChatContainer({
  sendMessage,
  messages,
  isLoadingMessages,
  isSendingMessage,
  dummyRand
}) {
  const { whitelabel } = useWhitelabel();
  const ref = useRef();
  const [ randomOptions, setRandomOptions ] = useState([]);
  const { company } = useContext(CompanyContext);
  const [ newMessage, setNewMessage ] = useState("");

  const onSendMessage = (message) => {
    setNewMessage("");
    sendMessage(message);
    ref.current.dispatchEvent(new KeyboardEvent('keydown',  {'key':'e'}));
  }

  const goToBottom = () => {
    var containerDiv = document.getElementById("messagebox");
    if (containerDiv) {
      setTimeout(() => {
        containerDiv.scrollTop = containerDiv.scrollHeight;
      }, 200);
    }
  }
  
  const resize = () => {
    ref.current.style.height = '44px';
    ref.current.style.height = `${Math.max(ref.current.scrollHeight, 0)}px`;
  }

  useEffect(() => {
    resize();
  }, [newMessage]);

  useEffect(() => {
    goToBottom();
  }, [messages?.length]);

  useEffect(() => {
    let _randomOptions = [
      {
        title: `Advice me`,
        subtitle: `on how to enhance ${company?.name}'s social networks`
      },
      {
        title: `Write a social media post`,
        subtitle: `about an important upcoming holiday`
      },
      {
        title: `Brainstorm 10 content ideas`,
        subtitle: `to generate engagement in social media`
      },
      {
        title: `Make a list`,
        subtitle: `of all the latest news related to ${company?.name} industry`
      },
      {
        title: `Provide recommendations`,
        subtitle: `for optimizing ${capitalize(socialNetworks?.random())} engagement and growth strategies.`,
      },
      {
        title: `Craft compelling content`,
        subtitle: `to captivate your audience on ${capitalize(socialNetworks?.random())} and drive meaningful interactions.`,
      },
      {
        title: `Brainstorm creative ideas`,
        subtitle: `for running engaging social media contests and giveaways.`,
      },
      {
        title: `Generate a list`,
        subtitle: `of effective hashtags to enhance the discoverability of your content on ${capitalize(socialNetworks?.random())}.`,
      },
      {
        title: `Share insights`,
        subtitle: `on using ${capitalize(socialNetworks?.random())} to showcase your brand's products and drive website traffic.`,
      },
      {
        title: `Offer guidance`,
        subtitle: `on creating engaging video content for TikTok to connect with a ${company?.audiences_types?.random() || `younger audience`}`,
      },
      {
        title: `Provide strategies`,
        subtitle: `for utilizing LinkedIn's publishing platform to establish thought leadership`,
      },
      {
        title: `Develop a plan`,
        subtitle: `for cross-promoting content across multiple social media platforms`,
      }
    ];
    _randomOptions = _randomOptions.sort(() => .5 - Math.random());
    _randomOptions.length = 4;
    setRandomOptions(_randomOptions);
  }, [dummyRand])

  return (
    <div className='flex-1 w-full h-full flex flex-col justify-between max-w-[750px] mx-auto'>
      <div className='flex-1 flex flex-col min-h-0 overflow-y-auto' id="messagebox">
        {!messages?.length && !isLoadingMessages && 
          <div className='flex-1 w-full flex flex-col items-center justify-center gap-2.5'>
            <div className='border border-gray-300 dark:border-gray-600 rounded-xl flex flex-col items-center justify-center h-[48px] w-[48px]'>
              <img src={whitelabel?.logo} className='!w-auto !h-[36px]' />
            </div>
            <h4 className='text-black dark:text-white text-xl text-center'>How can I help you today?</h4>
          </div>
        }
        {!!messages?.length &&
          <div className='flex-1 w-full flex flex-col-reverse gap-10 lg:gap-12 justify-end px-4 py-8 lg:px-8 lg:py-12'>
            {messages.map(aiResult => (
              <ChatTemplateMessage 
                aiResult={aiResult}
              />
            ))}
          </div>
        }
      </div>
      <div className='shrink-0 flex flex-col justify-center items-center px-4 gap-1 pb-2.5'>
        {!messages?.length && !isLoadingMessages && 
          <div className='flex flex-col lg:grid lg:grid-cols-2 px-2 gap-1.5 w-full mb-3'>
            {randomOptions?.map((quickOption,key) => (
              <div 
                key={key}
                onClick={() => onSendMessage(`${quickOption.title} ${quickOption.subtitle}`)}
                className={`relative group border border-tertiary-100 dark:border-gray-600 rounded-xl p-2.5 px-4 text-[14px] lg:text-[12px] cursor-pointer hover:bg-secondary-500 dark:hover:bg-gray-800 lg:!block ${key >= 2 && `hidden`}`}
              >
                <div className='flex justify-between items-center w-full'>
                  <div className='flex flex-col gap-0.5 w-full'>
                    <span className='font-bold text-tertiary-900 dark:text-white'>{quickOption.title}</span>
                    <span className='text-muted w-full overflow-hidden whitespace-nowrap text-ellipsis'>{quickOption.subtitle}</span>
                  </div>
                  <div className='absolute right-0 top-0 h-full opacity-0 rounded-xl pointer-events-none bg-gradient-to-r from-transparent via-white to-white dark:via-gray-800 dark:to-gray-800 flex items-center justify-center px-4 pl-12 group-hover:opacity-100 group-hover:pointer-events-auto'>
                    <Button 
                      icon={<TbSend />}
                      className="!rounded-lg !h-8 !w-8 !bg-tertiary-100 dark:!bg-gray-900 text-tertiary-900 dark:text-white"
                      size="sm"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        }
        <div className='relative w-full'>
          <Input 
            placeholder={`Message ${whitelabel?.name} AI`}
            className="w-full min-h-0 max-h-[200px] overflow-y-auto h-[44px] rounded-2xl py-3 px-4 text-black dark:text-white text-base dark:bg-gray-800"
            textArea={true}
            ref={ref}
            inputRef={ref}
            value={newMessage}
            disabled={isSendingMessage || isLoadingMessages}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyDown={(e) => e.key == `Enter` && !e.shiftKey && onSendMessage(e.target.value)}
          />
          <Button 
            variant="solid"
            icon={<TbSend />}
            className="!absolute right-2.5 bottom-2.5 mb-[1.5px] !rounded-lg !h-8 !w-8"
            size="sm"
            disabled={isSendingMessage || isLoadingMessages}
            onClick={() => onSendMessage(newMessage)}
          />
        </div>
        <span className='text-center text-tertiary-400 text-[11px]'>Right click on the selected text or click to create a post.</span>
      </div>
    </div>
  )
}
